export const GUI_FORM_ELEMENT_EVENT = {
  VOTE_TO_DISABLE_FORM_SUBMIT_ON_ENTER: "VOTE_TO_DISABLE_FORM_SUBMIT_ON_ENTER",
  CANCEL_VOTE_TO_DISABLE_FORM_SUBMIT_ON_ENTER: "CANCEL_VOTE_TO_DISABLE_FORM_SUBMIT_ON_ENTER",
  FORM_DATA_FETCHED: "FORM_DATA_FETCHED",
}
